<template>
  <div>
    <div class="esconder" id="svg-animado" style="width: 12rem; height: 7rem">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 809.66 222.58"
        style="enable-background: new 0 0 809.66 222.58"
        xml:space="preserve"
      >
        <g>
          <polygon
            class="stm"
            points="124.91,0 230.19,0 177.55,51.37 124.91,102.74 72.26,51.37 19.62,0 	"
          />
          <g>
            <polygon
              class="stm"
              points="113.66,113.75 28.34,28.68 0,0 0,202.36 45.58,202.36 45.58,106.1 113.66,173.98 		"
            />
            <polygon
              class="stm"
              points="136.14,113.75 221.46,28.68 249.8,0 249.8,202.36 204.22,202.36 204.22,106.1 136.14,173.98 		"
            />
          </g>
          <path
            class="stu"
            d="M311.47,202.51h-8.45c-27.49,0-45.25-14.71-45.25-37.47v-55.45h20v55.45c0,15.58,15.82,17.91,25.25,17.91h8.45
          c9.43,0,25.25-2.33,25.25-17.91v-55.45h20v55.45C356.72,187.8,338.96,202.51,311.47,202.51z"
          />
          <path d="M370.72,110.58" />
          <polygon
            class="stl"
            points="386.45,182.24 386.45,109.53 366.45,109.53 366.45,202.24 444.08,202.24 444.08,182.24 	"
          />
          <polygon
            class="ste"
            points="692.98,129.17 692.98,109.53 611.77,109.53 611.77,111.05 611.77,129.17 611.77,147.33 611.77,166.96 
          611.77,202.09 689.51,202.09 689.51,182.45 631.8,182.45 631.8,166.96 692.98,166.96 692.98,147.33 631.8,147.33 631.8,129.17 	"
          />
          <polygon
            class="stt"
            points="506.57,109.68 425.36,109.68 425.36,129.68 458.38,129.68 458.38,202.09 478.38,202.09 478.38,129.68 
          506.57,129.68 	"
          />
          <path
            class="stp"
            d="M572.08,109.68h-39.96H512.6h-0.49v92.42h20v-23.21h39.96c19.08,0,34.6-15.52,34.6-34.6
          C606.68,125.2,591.16,109.68,572.08,109.68z M572.08,158.89h-39.96v-29.21h39.96c8.05,0,14.6,6.55,14.6,14.6
          C586.68,152.34,580.13,158.89,572.08,158.89z"
          />
          <polygon
            class="stx"
            points="809.66,109.98 786.1,109.98 752.27,144.29 718.45,109.98 694.89,109.98 740.49,156.24 694.89,202.51 
          718.45,202.51 752.27,168.19 786.1,202.51 809.66,202.51 764.05,156.24 	"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script></script>

<style>
.stm {
  fill: gray;
  animation: animacaoM 1s forwards infinite;
}

.stm {
  fill: gray;
  animation: animacaoM 1s forwards infinite;
}

.stm {
  fill: gray;
  animation: animacaoM 1s forwards infinite;
}

.stu {
  fill: gray;
  animation: animacaoU 1s forwards infinite;
}

.stl {
  fill: gray;
  animation: animacaoL 1s forwards infinite;
}

.stt {
  fill: gray;
  animation: animacaoT 1s forwards infinite;
}

.stp {
  fill: gray;
  animation: animacaoP 1s forwards infinite;
}

.ste {
  fill: gray;
  animation: animacaoE 1s forwards infinite;
}

.stx {
  fill: gray;
  animation: animacaoX 1s forwards infinite;
}

@keyframes animacaoM {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: #182e86;
  }

  40% {
    fill: #182e86;
  }

  50% {
    fill: #182e86;
  }

  60% {
    fill: #182e86;
  }

  70% {
    fill: #182e86;
  }

  80% {
    fill: #182e86;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoU {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: #182e86;
  }

  50% {
    fill: #182e86;
  }

  60% {
    fill: #182e86;
  }

  70% {
    fill: #182e86;
  }

  80% {
    fill: #182e86;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoL {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: gray;
  }

  50% {
    fill: gray;
  }

  60% {
    fill: #182e86;
  }

  70% {
    fill: #182e86;
  }

  80% {
    fill: #182e86;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoT {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: gray;
  }

  50% {
    fill: gray;
  }

  60% {
    fill: gray;
  }

  70% {
    fill: #182e86;
  }

  80% {
    fill: #182e86;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoP {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: gray;
  }

  50% {
    fill: gray;
  }

  60% {
    fill: gray;
  }

  70% {
    fill: gray;
  }

  80% {
    fill: #182e86;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoE {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: gray;
  }

  50% {
    fill: gray;
  }

  60% {
    fill: gray;
  }

  70% {
    fill: gray;
  }

  80% {
    fill: gray;
  }

  90% {
    fill: #182e86;
  }

  100% {
    fill: #182e86;
  }
}

@keyframes animacaoX {
  0% {
    fill: gray;
  }

  10% {
    fill: gray;
  }

  20% {
    fill: gray;
  }

  30% {
    fill: gray;
  }

  40% {
    fill: gray;
  }

  50% {
    fill: gray;
  }

  60% {
    fill: gray;
  }

  70% {
    fill: gray;
  }

  80% {
    fill: gray;
  }

  90% {
    fill: gray;
  }

  100% {
    fill: #182e86;
  }
}
</style>
